import {
  container,
  title,
  main,
  whiteColor,
  grayColor,
  mainRaised,
  hexToRgb
} from "assets/jss/material-kit-pro-react.js";
import footerStyle from "assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.js";

const presentationStyle = {
  ...footerStyle,
  main: {
    ...main
    /*overflow: "hidden"*/
  },
  mainRaised,
  parallax: {
    height: "90vh",
    overflow: "hidden"
  },
  cards: {
    position: "relative",
    marginTop: "-230px",
    marginBottom: "-70px",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  container: {
    ...container,
    zIndex: 1
  },
  containerAccueil: {
    ...container,
    paddingTop: "80px",
    paddingBottom: "80px",
    zIndex: 1
  },
  title: {
    ...title,
    color: whiteColor
  },
  titleright: {
    ...title,
    textAlign: "right",
    color: whiteColor
  },
  titleQuote: {
    textAlign: "right",
    color: whiteColor
  },
  brand: {
    color: whiteColor,
    textAlign: "center",
    "& h1": {
      fontSize: "4.2rem",
      fontWeight: "600",
      display: "inline-block",
      position: "relative"
    }
  },
  footer: {
    padding: "0.3375rem 0",
    textAlign: "center",
  },
  minSizeY: {
    padding: "30px",
  },
  captionlogo:{
    fontSize: "8px",
  },
  proBadge: {
    position: "relative",
    fontSize: "22px",
    textTransform: "uppercase",
    fontWeight: "700",
    right: "-10px",
    padding: "10px 18px",
    top: "-30px",
    background: whiteColor,
    borderRadius: "3px",
    color: grayColor[18],
    lineHeight: "22px",
    boxShadow: "0 5px 5px -2px rgba(" + hexToRgb(grayColor[25]) + ",.4)"
  },
};

export default presentationStyle;
